module.exports = __webpack_public_path__ + "static/media/contact_background.5f8acf78.jpg";